import React, { useState, useEffect } from "react";
import { db } from "../../firebaseConfig";
import {
  collection,
  addDoc,
  getDocs,
  query,
  where,
  serverTimestamp,
} from "firebase/firestore";
import { toStorageDate } from "../../utils/date";

const AdminAddTraseu = () => {
  const [form, setForm] = useState({
    numePrenume: "",
    telefon: "",
    email: "",
    varsta: "",
    inaltime: "",
    greutate: "",
    tipTraseu: "",
    dataTraseu: "",
  });

  const [availableDates, setAvailableDates] = useState([]);
  const [popup, setPopup] = useState({
    show: false,
    message: "",
    success: true,
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const showPopup = (message, success = true) => {
    setPopup({ show: true, message, success });
    setTimeout(
      () => setPopup({ show: false, message: "", success: true }),
      3000
    );
  };

  // 🔹 Când selectăm tipul traseului, încărcăm datele disponibile
  useEffect(() => {
    const fetchDates = async () => {
      if (!form.tipTraseu) return setAvailableDates([]);

      try {
        const tipUpper = form.tipTraseu.toUpperCase();

        // încercăm query direct
        const q = query(
          collection(db, "stabilire_program"),
          where("tipProgram", "==", tipUpper)
        );
        const snap = await getDocs(q);

        let dates = snap.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        // fallback — dacă nu a găsit nimic (din cauza majusculelor / lipsă index)
        if (dates.length === 0) {
          const allSnap = await getDocs(collection(db, "stabilire_program"));
          const allPrograms = allSnap.docs.map((d) => d.data());
          dates = allPrograms
            .filter((p) => (p.tipProgram || "").toUpperCase() === tipUpper)
            .map((p) => ({ data: p.data, ora: p.ora, locatie: p.locatie }));
        }

        const normalized = dates.map((item) => ({
          ...item,
          data: toStorageDate(item.data) || item.data,
        }));
        setAvailableDates(normalized);
      } catch (err) {
        console.error("❌ Eroare la preluarea datelor:", err);
        showPopup("❌ Nu s-au putut prelua datele pentru acest tip!", false);
      }
    };

    fetchDates();
  }, [form.tipTraseu]);

  // 🔹 Trimite formularul
  const handleSubmit = async () => {
    try {
      const {
        numePrenume,
        telefon,
        email,
        varsta,
        inaltime,
        greutate,
        tipTraseu,
        dataTraseu,
      } = form;
      if (
        !numePrenume ||
        !telefon ||
        !email ||
        !varsta ||
        !inaltime ||
        !greutate ||
        !tipTraseu ||
        !dataTraseu
      ) {
        showPopup("⚠️ Completează toate câmpurile!", false);
        return;
      }

      await addDoc(collection(db, "inscrieri_traseu"), {
        ...form,
        createdAt: serverTimestamp(),
      });

      showPopup("✅ Înscriere adăugată cu succes!", true);
      setForm({
        numePrenume: "",
        telefon: "",
        email: "",
        varsta: "",
        inaltime: "",
        greutate: "",
        tipTraseu: "",
        dataTraseu: "",
      });
      setAvailableDates([]);
    } catch (err) {
      console.error("Eroare Firebase:", err);
      showPopup("❌ Eroare la trimiterea înscrierii!", false);
    }
  };

  return (
    <div className="admin-card admin-traseu admin-row2-card relative">
      {/* 🔸 Popup */}
      {popup.show && (
        <div
          className={`absolute inset-0 flex items-center justify-center rounded-xl text-white font-semibold text-sm
          ${
            popup.success ? "bg-green-600/90" : "bg-red-600/90"
          } transition-all duration-500`}
        >
          {popup.message}
        </div>
      )}

      <h3 className="admin-card-header">Înscriere traseu</h3>

      <div className="admin-card-grid-2">
        {/* Nume */}
        <div className="admin-field">
          <label className="admin-label">Nume și Prenume</label>
          <input
            className="admin-input"
            name="numePrenume"
            value={form.numePrenume}
            onChange={handleChange}
            placeholder="Ex: Popescu Alin"
          />
        </div>

        {/* Telefon */}
        <div className="admin-field">
          <label className="admin-label">Telefon</label>
          <input
            className="admin-input"
            name="telefon"
            value={form.telefon}
            onChange={handleChange}
            placeholder="07xxxxxxxx"
          />
        </div>

        {/* Email */}
        <div className="admin-field">
          <label className="admin-label">Email</label>
          <input
            className="admin-input"
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder="exemplu@gmail.com"
          />
        </div>

        {/* Vârstă */}
        <div className="admin-field">
          <label className="admin-label">Vârstă</label>
          <input
            type="number"
            className="admin-input"
            name="varsta"
            value={form.varsta}
            onChange={handleChange}
            placeholder="Ex: 25"
          />
        </div>

        {/* Înălțime */}
        <div className="admin-field">
          <label className="admin-label">Înălțime (cm)</label>
          <input
            type="number"
            className="admin-input"
            name="inaltime"
            value={form.inaltime}
            onChange={handleChange}
            placeholder="Ex: 175"
          />
        </div>

        {/* Greutate */}
        <div className="admin-field">
          <label className="admin-label">Greutate (kg)</label>
          <input
            type="number"
            className="admin-input"
            name="greutate"
            value={form.greutate}
            onChange={handleChange}
            placeholder="Ex: 70"
          />
        </div>

        {/* Tip Traseu */}
        <div className="admin-field">
          <label className="admin-label">Tip Traseu</label>
          <select
            name="tipTraseu"
            className="admin-select"
            value={form.tipTraseu}
            onChange={handleChange}
          >
            <option value="">Selectează...</option>
            <option value="MAI">MAI</option>
            <option value="MAPN">MAPN</option>
            <option value="ISU">ISU</option>
            <option value="ANP">ANP</option>
          </select>
        </div>

        {/* Data traseu */}
        <div className="admin-field">
          <label className="admin-label">Data traseu</label>
          <select
            name="dataTraseu"
            className="admin-select"
            value={form.dataTraseu}
            onChange={handleChange}
            disabled={!availableDates.length}
          >
            <option value="">
              {availableDates.length
                ? "Selectează data"
                : "Alege mai întâi tipul traseului"}
            </option>
            {availableDates.map((d, i) => (
              <option key={i} value={d.data}>
                {`${d.data} — ${d.ora || ""} ${
                  d.locatie ? `(${d.locatie})` : ""
                }`}
              </option>
            ))}
          </select>
        </div>
      </div>

      <button className="admin-button mt-3" onClick={handleSubmit}>
        Adaugă înscriere
      </button>
    </div>
  );
};

export default AdminAddTraseu;
